
// Section titles for the application form
export const SECTIONS = [
  'Contact Information',
  'Organization Information', 
  'Benefits Details',
  'Operations & Risk',
  'Employee Health Assessment',
  'Payroll Schedule',
  'Census Information',
  'Document Upload',
  'PEO Preferences',
  'Review & Submit'
];

// Validation section mapping for different sections
export const VALIDATION_SECTIONS = {
  'Contact Information': 'Contact Information',
  'Organization Information': 'Organization Information',
  'Benefits Details': 'Benefits Details',
  'Operations & Risk': 'Operations & Risk',
  'Employee Health Assessment': 'Employee Health Assessment',
  'Payroll Schedule': 'Payroll Schedule',
  'Census Information': 'Census Information',
  'Document Upload': 'Document Upload',
  'PEO Preferences': 'PEO Preferences',
  'Review & Submit': 'Review & Submit'
};
